const getTime = (time) => {
  if (!time) {
    return '';
  }

  let parsedTime = time.split(':');

  let hours = Number(parsedTime[0]);
  let minutes = Number(parsedTime[1]);

  let translatedTime;

  if (hours > 0 && hours <= 12) {
    translatedTime = '' + hours;
  } else if (hours > 12) {
    translatedTime = '' + (hours - 12);
  } else if (hours === 0) {
    translatedTime = '12';
  }

  translatedTime += (minutes < 10) ? ':0' + minutes : ':' + minutes;
  translatedTime += (hours >= 12) ? ' pm' : ' am';

  return translatedTime;
};

export const getStoreDetailStructureData = (type, data = {}, isReviewPage = false) => {
  let structuredData = {
    '@context': 'https://schema.org'
  };
  const {
    storeId,
    name, phone, storeDetailsPageLink, storeHours
  } = data?.storeData?.storeSearch?.stores?.[0] || {};
  const { city, state, postalCode, street } = data?.storeData?.storeSearch?.stores?.[0]?.address || {};
  const { sunday, monday } = storeHours || {};
  const { Includes, Results } = data?.reviewData?.storeReviews || {};
  const { AverageOverallRating = 0, TotalReviewCount } = Includes?.Products?.store?.FilteredReviewStatistics || {};

  if (type === 'LocalBusiness') {
    structuredData = {
      ...structuredData,
      '@type': 'LocalBusiness',
      address: {
        '@type': 'PostalAddress',
        addressLocality: city,
        addressRegion: state,
        postalCode,
        streetAddress: street
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        itemReviewed: `The Home Depot #${storeId} ${city}`,
        ratingValue: AverageOverallRating,
        bestRating: '5',
        reviewCount: TotalReviewCount
      },
      review: Results && Results.map((review) => {
        return ({
          '@type': 'Review',
          author: review.UserNickname,
          reviewBody: review.ReviewText,
          name: review.Title,
          reviewRating: {
            '@type': 'Rating',
            bestRating: '5',
            ratingValue: review.Rating
          }
        });
      }),
      name,
      openingHours: [
        `Mon-Sat ${getTime(monday?.open)} - ${getTime(monday?.close)}`,
        `Sun ${getTime(sunday?.open)} - ${getTime(sunday?.close)}`
      ],
      telephone: phone,
      url: 'https://www.homedepot.com' + storeDetailsPageLink
    };
  }

  return structuredData;
};